// extracted by mini-css-extract-plugin
export var breadcrumbPadding = "component-module--breadcrumbPadding--5627c";
export var heroTeaserButtonBlock = "component-module--heroTeaserButtonBlock--e5f7c";
export var heroTeaserCard = "component-module--heroTeaserCard--ca1fe";
export var heroTeaserContainer = "component-module--heroTeaserContainer--9740b";
export var heroTeaserSection = "component-module--heroTeaserSection--84d38";
export var heroTeaserSwiper = "component-module--heroTeaserSwiper--93436";
export var heroTeaserSwiperBlock = "component-module--heroTeaserSwiperBlock--f23e3";
export var heroTeaserTextBlock = "component-module--heroTeaserTextBlock--70aff";
export var lightColor = "component-module--lightColor--f1358";
export var noOuterSectionPadding = "component-module--noOuterSectionPadding--fdee3";
export var paginationElement = "component-module--paginationElement--1a1af";
export var sliderControls = "component-module--sliderControls--30609";